import React from 'react'
import { Container } from 'react-bootstrap'
import "./MeteFooter.scss"

function MeteFooter() {
  return (
    <Container className='footer-cont'>
      <div className="inner">
        <p>Copyright © 2023-Present mete & design· </p>
      </div>
    </Container>
  )
}

export default MeteFooter
